var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "custom-callout",
        {
          staticClass: "mb-4 custom-callout-invoice",
          attrs: {
            "border-color": "gray-5",
            "has-toggle": false,
            opened: _vm.toggleEditPanel
          },
          scopedSlots: _vm._u(
            [
              _vm.toggleEditPanel
                ? {
                    key: "edition",
                    fn: function() {
                      return [
                        _c("div", { staticClass: "bg-secondary-3 p-3" }, [
                          _c(
                            "div",
                            { staticClass: "bg-white rounded p-2 pl-4" },
                            [
                              _c("div", { staticClass: "row py-1" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "dot d-flex justify-content-center align-items-center py-2 px-1 mt-2"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "orange-icon orange-icon-badge-align fa fa-edit"
                                        })
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center align-items-center py-1 px-1 mt-2 ml-2 font-weight-bold font-14"
                                      },
                                      [_vm._v(" Editar Ajuste ")]
                                    )
                                  ])
                                ])
                              ]),
                              _c(
                                "validation-observer",
                                {
                                  ref: "editAdjustmentRef",
                                  staticClass: "pr-4",
                                  attrs: { novalidate: "", tag: "form" }
                                },
                                [
                                  _c("div", { staticClass: "row mt-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-14 color-gray-6 mb-1"
                                          },
                                          [
                                            _vm._v(
                                              " ¿Qué tipo de ajuste desea realizar? "
                                            )
                                          ]
                                        ),
                                        _c("validation-provider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("custom-radio", {
                                                      staticClass:
                                                        "mt-3 radio-custom font-14",
                                                      attrs: {
                                                        id: `adjustment-adjustmentType-${_vm.data.requestAdjustmentId}-`,
                                                        "custom-error-msg":
                                                          "El tipo de ajuste es requerido.",
                                                        error: Boolean(
                                                          errors[0]
                                                        ),
                                                        "is-inline": "",
                                                        name: `adjustmentType-${_vm.data.requestAdjustmentId}`,
                                                        options:
                                                          _vm.adjustmentOptions
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model
                                                            .adjustmentType,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.model,
                                                            "adjustmentType",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "model.adjustmentType"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            4225244964
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 col-sm-12" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-14 color-gray-6 mb-1"
                                          },
                                          [_vm._v(" Cantidad a ajustar: ")]
                                        ),
                                        _c("validation-provider", {
                                          attrs: {
                                            "custom-messages": {
                                              required:
                                                "La cantidad es requerida.",
                                              greaterThanZeroCustomMsg:
                                                "La cantidad deber ser mayor a 0."
                                            },
                                            rules: "required|greaterThanZero"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group mb-3"
                                                      },
                                                      [
                                                        _c("custom-input", {
                                                          ref:
                                                            "adjustmentAmount",
                                                          staticClass: "w-70",
                                                          class:
                                                            _vm.getAmountClass,
                                                          attrs: {
                                                            id: `adjustment-amount-${_vm.data.requestAdjustmentId}`,
                                                            "custom-error-msg":
                                                              "La cantidad deber ser mayor a 0.",
                                                            error: errors[0],
                                                            "mask-type":
                                                              "Money",
                                                            placeholder: "0.00",
                                                            "prepend-icon":
                                                              _vm.getAmountIcon,
                                                            type: "number"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.model.amount,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.model,
                                                                "amount",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "model.amount"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2803812432
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-md-4 text-right mt-3"
                                      },
                                      [
                                        _c(
                                          "action-button",
                                          {
                                            attrs: {
                                              i: "fas fa-times-circle",
                                              variant:
                                                "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onCancelEditAdjustment()
                                              }
                                            }
                                          },
                                          [_vm._v(" Cancelar ")]
                                        ),
                                        _c(
                                          "action-button",
                                          {
                                            attrs: {
                                              i: "fas fa-save",
                                              variant: "success pl-4 pr-4"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onSaveEditAdjustment()
                                              }
                                            }
                                          },
                                          [_vm._v(" Guardar ")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          )
        },
        [
          _c("div", { staticClass: "row py-3" }, [
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Fecha del Ajuste: ")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-normal" },
                [
                  _vm._v(
                    " " + _vm._s(_vm.formatDate(_vm.data.createdDate)) + " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-5 mt-3 mt-md-0 mt-sm-3" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Razón del Ajuste: ")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-normal" },
                [_vm._v(" " + _vm._s(_vm.data.reason) + " ")]
              )
            ]),
            _c("div", { staticClass: "col-md-2 mt-3 mt-md-0 mt-sm-3" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Cantidad de Ajuste: ")
              ]),
              _c(
                "div",
                {
                  staticClass: "font-weight-bold font-16",
                  class: _vm.getAmountColor(_vm.data.amount)
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.getAdjustmentAmount(_vm.data.amount)) + " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-2 mt-3 mt-md-0 mt-sm-3" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Usuario: ")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-normal" },
                [_vm._v(" " + _vm._s(_vm.data.userFullName) + " ")]
              )
            ])
          ]),
          _c("hr"),
          _c("div", { staticClass: "row pb-3" }, [
            _c("div", { staticClass: "col-md-8" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Comentario del Ajuste: ")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-normal" },
                [_vm._v(" " + _vm._s(_vm.data.comments) + " ")]
              )
            ]),
            _c(
              "div",
              { staticClass: "col-12 offset-md-1 col-md-3 mt-3 text-right" },
              [
                _vm.canShowEdit
                  ? _c("action-button", {
                      staticClass: "success edit-btn mr-2",
                      attrs: { id: "btn-edit-adjustment", i: "fa fa-edit" },
                      on: {
                        click: function($event) {
                          return _vm.onEditAdjustment()
                        }
                      }
                    })
                  : _vm._e(),
                _vm.canShowDelete
                  ? _c(
                      "action-button",
                      {
                        attrs: {
                          id: "btn-delete-adjustment",
                          i: "fas fa-minus-circle",
                          variant:
                            "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onDeleteAdjustment()
                          }
                        }
                      },
                      [_vm._v(" Eliminar ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }